
import { Container } from "@/components/ui/container";

export const ProcessSteps = () => {
  const steps = [
    {
      title: "Tailored Assessment",
      description: "We start by understanding your unique business context, existing security measures, and specific compliance requirements to create a customized security roadmap."
    },
    {
      title: "Systematic Implementation",
      description: "Our step-by-step approach ensures minimal disruption while maximizing security improvements, with clear communication at every stage."
    },
    {
      title: "Continuous Optimization",
      description: "We don't just set and forget. Our team continuously monitors, adjusts, and improves your security posture as threats evolve."
    }
  ];

  return (
    <section className="py-16 bg-gray-50" id="process">
      <Container>
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-4">
            How We Transform Your Security
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Our proven methodology combines deep Microsoft expertise with a human-centric approach to security implementation.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-xl border border-purple-100 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="w-12 h-12 bg-edgefi-purple/10 rounded-full flex items-center justify-center mb-6">
                <span className="text-edgefi-purple font-bold">{index + 1}</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};
